// Base URL used only so relative paths can be parsed during SSR/tests.
const DEFAULT_PAGE_VIEW_ORIGIN = "https://reputech.local";
const ALLOWED_PAGE_VIEW_QUERY_PARAMS = new Set([
  "fbclid",
  "gad_source",
  "gbraid",
  "gclid",
  "msclkid",
  "wbraid",
]);

const getPageViewOrigin = (): string => {
  if (typeof window === "undefined") {
    return DEFAULT_PAGE_VIEW_ORIGIN;
  }

  return window.location.origin;
};

const isAllowedPageViewQueryParam = (paramName: string): boolean => {
  return (
    paramName.startsWith("utm_") || ALLOWED_PAGE_VIEW_QUERY_PARAMS.has(paramName)
  );
};

// Keep only attribution query params at both call sites: trackers use this for
// dedupe, and public analytics helpers sanitize again before pushing dataLayer.
export const sanitizePageViewPath = (path: string): string => {
  const pageUrl = new URL(path, getPageViewOrigin());
  const sanitizedSearchParams = new URLSearchParams();

  pageUrl.searchParams.forEach((value, key) => {
    if (isAllowedPageViewQueryParam(key)) {
      sanitizedSearchParams.append(key, value);
    }
  });

  const sanitizedSearch = sanitizedSearchParams.toString();
  return `${pageUrl.pathname}${sanitizedSearch ? `?${sanitizedSearch}` : ""}`;
};
